import {
	generatedBooleanFeatureFlagKeys,
	getGeneratedBooleanFeatureFlags,
} from '../../__generated__/platform-boolean-feature-flags';

export const getAllBooleanFeatureFlags = () => {
	try {
		const generatedFeatureFlags = getGeneratedBooleanFeatureFlags() || {};
		return generatedFeatureFlags;
	} catch (error) {
		return {};
	}
};

export const getAllBooleanFeatureFlagKeys = () => {
	if (typeof generatedBooleanFeatureFlagKeys === 'object') {
		return generatedBooleanFeatureFlagKeys;
	}
	return [];
};
